import React from 'react';
import bannerLight from '../assets/image/banner_light.png';
import bannerDark from '../assets/image/banner_dark.png';

export default function Banner({ className = '', framed = false }) {
  // framed=true preserves the previous bordered/frame appearance;
  // default (framed=false) renders the image flush with the page to avoid a visible box.
  const containerBase = framed ? 'w-full overflow-hidden rounded-lg border border-gray-200 dark:border-gray-700 bg-white/60' : 'w-full overflow-hidden';
  return (
    <div className={`${containerBase} ${className}`}>
      {/* Light banner */}
      <img src={bannerLight} alt="banner" className="w-full h-28 sm:h-36 object-contain block dark:hidden" />
      {/* Dark banner */}
      <img src={bannerDark} alt="banner-dark" className="w-full h-28 sm:h-36 object-contain hidden dark:block" />
    </div>
  );
}
